// extracted by mini-css-extract-plugin
export default {"footerContainer":"ChangePasswordPoupControl_footerContainer__u2PRY"};